module.exports = __webpack_public_path__ + "img/tzzgx.9f06b2e7.png";